"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpeDisplayType = exports.DpeLogoSize = exports.DpePartner = exports.DpeTileStep = void 0;
var DpeTileStep;
(function (DpeTileStep) {
    DpeTileStep[DpeTileStep["INTRO"] = 1] = "INTRO";
    DpeTileStep[DpeTileStep["VALIDATION"] = 2] = "VALIDATION";
    DpeTileStep[DpeTileStep["CONFIRMATION"] = 3] = "CONFIRMATION";
})(DpeTileStep || (exports.DpeTileStep = DpeTileStep = {}));
var DpePartner;
(function (DpePartner) {
    DpePartner["VITALITY"] = "vitality";
})(DpePartner || (exports.DpePartner = DpePartner = {}));
var DpeLogoSize;
(function (DpeLogoSize) {
    DpeLogoSize["SMALL"] = "small";
    DpeLogoSize["MEDIUM"] = "medium";
    DpeLogoSize["LARGE"] = "large";
})(DpeLogoSize || (exports.DpeLogoSize = DpeLogoSize = {}));
var DpeDisplayType;
(function (DpeDisplayType) {
    DpeDisplayType["BUTTON"] = "button";
    DpeDisplayType["LABEL"] = "label";
})(DpeDisplayType || (exports.DpeDisplayType = DpeDisplayType = {}));
//# sourceMappingURL=DpeTypes.js.map